import { FileLikeObject } from 'ng2-file-upload';

export class FileUploaderModel {
    constructor(public fileItem: FileLikeObject, public fileApiId: string, public fileSize: number) {

    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/file-uploader/file-uploader.model.ts